const splitArray = (array:[], parts:number) => {
  if (parts < 1) {
    return [array]
  }
  const result = [];
  const chunkSize = Math.ceil(array.length / parts);

  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }

  return result;
}

const mergeSubtitle = (sentenceWords:[], start:number, trim:number) =>{
  let sentence = ``
  let startAt = 0
  let end = 0
  let position = 0
  sentenceWords.map((data:any) => {
    const text = data?.text;
    const wordLength = text.length;
    const posEnd = position + wordLength;
    const duration = ( data?.timeRange?.end - data?.timeRange?.start );
    if (!sentence) {
      startAt = data?.actualStart-trim
    }
    if( data.actualStart ){
      end = data.actualStart - trim + duration;
    }
    sentence += `${sentence ? ' ' : ''}${data?.text}`
    // we adjust next start to previous end
    data.timeRange = {
      start: data?.actualStart - startAt - trim,
      end: (data?.actualStart - startAt - trim) + duration,
    }
    data.position = {
      start : position,
      end : posEnd,
      index : 0
    }
    position = posEnd + 1;
  })
  return {
    metadata : {
      text:sentence,
      styleType : 'SIMPLE',
      wordInterval:sentenceWords,
    },
    type: "subtitle",
    startAt : start + startAt/10,
    totalDuration: (end - startAt)/1000,
  }
}
export const split = (data:any, start:number, trim:number, maxLength:number = 30) => {
  const result = []
  let startAt = 0
  let position = 0
  let sentence = ''
  let wordInterval:any = []
  for (const words of data?.words) {
    if (!sentence) {
      startAt = words?.start - trim
    }
    sentence += `${sentence ? ' ' : ''}${words.text}`
    const wordLength = words?.text.length;
    const posEnd = position + wordLength;
    let durationStart = words?.start - startAt - trim;
    durationStart = durationStart > 0 ? durationStart : 0;
    let durationEnd = words?.end - startAt - trim;
    durationEnd = durationEnd > 0 ? durationEnd : 0;
    let data = {
      text: words?.text,
      position: {
        start : position,
        end : posEnd,
        index : 0
      },
      timeRange: {
        start: durationStart,
        end: durationEnd
      },
      actualStart:words?.start,
      // generated:true,
      // confidence:words?.confidence,
      // speaker:words?.speaker,
    }
    wordInterval.push(data);
    position = posEnd + 1;

    if (
      words?.text?.includes('!') ||
      words?.text?.includes('.') ||
      words?.text?.includes('?')
    ) {
      if ( sentence.length > maxLength) {
        const splitLength = Math.ceil(sentence.length/maxLength)
        const sentenceList = splitArray(wordInterval,splitLength);
        sentenceList.map((sentenceWords:any)=>{
          result.push(
            mergeSubtitle(sentenceWords, start, trim)
          )
        })
      } else {
        result.push({
          metadata : {
            text:sentence,
            styleType : 'SIMPLE',
            wordInterval,
          },
          type: "subtitle",
          startAt : start + startAt/10,
          totalDuration: (words.end - startAt-trim)/1000
        })
      }
      sentence = ''
      startAt = 0
      wordInterval = []
      position = 0;
    }
  }
  return result;
}